import { useMutation } from "@tanstack/react-query";
import usePrivateAxios from "@/common/api/usePrivateAxios";
import { AxiosError } from "axios";

interface UseEnableTmaisClientProps {
  id?: string;
  onSuccess?: () => void;
  onError?: (error: AxiosError) => void;
}

const useEnableTmaisClient = ({ id, onSuccess, onError }: UseEnableTmaisClientProps) => {
  const privateAxios = usePrivateAxios();
  return useMutation<void, AxiosError>({
    mutationKey: ['enableTmaisUser', id],
    mutationFn: async (data) => {
      await privateAxios.post(`/tmais/users/${id}/enable`, data);
    },
    onSuccess,
    onError,
  });
};

export default useEnableTmaisClient;
